"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SVBSearchExplore;
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function SVBSearchExplore(props) {
  const {
    exploreLabel,
    exploreBtntext,
    exploreLink
  } = props;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "col-md-12"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "d-flex explore align-items-center justify-content-between p-3 mt-3 mb-3"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "explore-label"
  }, !exploreLabel ? 'Explore what SVB has to offer!' : exploreLabel), /*#__PURE__*/_react.default.createElement("div", {
    className: "explore-button"
  }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
    to: !exploreLink ? '/apis/docs-home' : exploreLink,
    className: "explore-btn"
  }, !exploreBtntext ? 'Browse API Catalog' : exploreBtntext))));
}
SVBSearchExplore.propTypes = {
  exploreLabel: _propTypes.default.string,
  exploreBtntext: _propTypes.default.string,
  exploreLink: _propTypes.default.string
};